import Type from "@/model/types/Type";

const type = {
    BOOLEAN : 1,
    INTEGER : 2,
    DOUBLE : 3,
    STRING : 4,
    DATE : 5
}

const list = [
    {value: 2, text: "Inteiro"},
    {value: 3, text: "Decimal"},
    {value: 4, text: "Texto"},
    {value: 5, text: "Data"},
    {value: 1, text: "Sim/Não"},
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains
}